module.exports = __webpack_public_path__ + "static/media/image 1 (3).32f37865.png";